export function eventProducts() {
    $('.holder-event-products input[type=radio]').on('change', function () {
        $(this).closest('.item-product').find('a.add-to-cart').attr('href', '?add-to-cart=' + this.value + '&quantity=1')
    });

    $('.holder-event-products .item-product').each(function () {
        let $this = $(this);

        $this.find('input[type=checkbox]').on('change', function () {
            let $check_privacy = $this.find("input[type='checkbox']");

            if($check_privacy.length === $check_privacy.filter(":checked").length){
                $this.find('.button').removeClass('isDisabled');
            } else {
                $this.find('.button').addClass('isDisabled');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/event-products.js